<template>
	<div v-if="isActive || selected" class="list-group-item col-xs-12" :class="{disabled: remainingForFreeShipping && shippingMethod.id === 20, active: this.selected && this.isActive}">
		<div class="col-xs-12 shipping-header">
			<label class="radio-checkbox-label radio-inline col-xs-12 pr-0" :class="{'mb-3': !(remainingForFreeShipping && shippingMethod.id === 20)}">
				<input class="checkbox" type="radio" :checked="selected" />
				<span class="checkbox-custom">
					<span v-if="selected && isActive" class="checkbox-dot" />
					<span v-else-if="selected && ! isActive" class="glyphicon glyphicon-ok ok-mark" />
				</span>
				<span class="col-xs-9 shipping-name">{{ shippingMethod.name }} <preorder-info v-if="! isReleased" /></span>
				<div v-if="isActive" class="pull-right">
					<span v-if="hasRebate && price < 130 && price > 0" class="has-rebate">{{ formattedPrice }}</span>
					<span>{{ priceToPayIsZero ? "0 kr" : formattedPrice }}</span>
				</div>
				<span v-else class="pull-right">Ändra</span>
			</label>
			<div v-if="shippingMethod.id === 20 && remainingForFreeShipping" class="ml-5 col-xs-12 no-col-padding" :class="{ 'ap-br': hasOptions }" style="margin-top: -5px;">
				<small class="sub-title ml-5">{{ remainingForFreeShipping }}</small>
			</div>

		</div>
		<div v-if="! isDownload" class="shipping-stock-delivery col-xs-12">
			<div class="expected-delivery col-xs-9 col-md-10">
				<span v-if="! (hasOptions && selected) || ! isActive" :class="['stock-icon', stockClass]" />
				<!-- <p v-if="shippingMethod.options && shippingMethod.options[0].description !== ''" class="sub-title">
					{{ shippingMethodOptions[selectedDropdownIndex].label }}
				</p> -->
				<p v-if="availableOptions && (! selected || ! isActive)" class="sub-title">
					{{ this.stockAvailability.releaseDate ? 'Release ' + this.getUnreleasedDate() : ! stockAvailability.inWebStock ? tc('STORE_OUT_OF_STOCK') : this.shippingMethod.providerCode === 'POSTNORD' ? this.getDeliveryInfo : availableOptions[selectedDropdownIndex].description }}
				</p>
				<p v-else-if="! availableOptions" class="sub-title">
					<!-- {{ getDeliveryInfo }} -->
					{{ this.stockAvailability.releaseDate ? 'Release ' + this.getUnreleasedDate() : ! stockAvailability.inWebStock ? tc('STORE_OUT_OF_STOCK') : shippingMethod.isPostnordPallet ? 'Förväntad leverans 1-2 vardagar' : this.shippingMethod.providerCode === 'POSTNORD' ? this.getDeliveryInfo : shippingMethod.description }}
				</p>
			</div>
			<div v-if="isActive" class="col-xs-3 col-md-2 pr-0">
				<img v-if="shippingMethod.imageUrl"
					:src="shippingMethod.imageUrl"
					class="shipping-icon"
					alt="shipping-icon"
				/>
			</div>
		</div>
		<template v-if="hasOptions && selected && isActive">
			<br>
			<dropdown-select :value="shippingMethodOptions[selectedDropdownIndex]" :items="shippingMethodOptions" fullWidth @select="handleDropdownSelect" />
		</template>
		<!-- <span v-if="selected && isActive && showSubTitle" class="list-group-item-text sub-title" v-html="shippingMethod.description" /> -->
		<span v-if="selected && isActive" class="list-group-item-text sub-title" v-html="shippingMethod.isPostnordPallet ? tp('PALLET_DESCRIPTION') : (hasOptions || shippingMethod.id === 3) ? shippingMethod.description : ''" />
		<div v-if="selected && isActive && shippingMethod.isPostnordPallet" class="postnord-time-slots">
			<span class="sub-title semibold">Leveranstider för ditt postnummer</span>
			<div v-for="(timeSlot, index) in shippingMethod.postnordPalletTimeSlots" class="time-slot" :key="'time-slot-' + index">
				{{ timeSlot.day }}
				<span class="small">{{ timeSlot.timeRange }}</span>
			</div>
			<span class="sub-title">{{ tp('BOOKING') }}</span>
		</div>
	</div>
</template>

<script>
import bus from 'eventbus';
import { mapState } from 'vuex';
import stockUtils from 'utils/stock';
import { convertToCdnUrl, formatPrice, releaseToString, formatProductPrice } from 'utils';
import businessVariables from 'businessVariables';
import localSessionStorage from 'localSessionStorage';
import { getCartSum, hasUnreleasedProducts } from 'utils/cart';
import { t } from 'datastore/i18n';

import format from 'date-fns/format';
import svLocale from 'date-fns/locale/sv';
import differenceInDays from 'date-fns/difference_in_days';
export default {
	props: {
		cart: {
			type: Object,
			required: true,
		},
		shippingMethod: {
			type: Object,
			required: true,
		},
		selectedMethodId: {
			type: Number,
			default: null,
		},
		selectedZipCode: {
			type: Number,
		},
		stockAvailability: {
			type: Object,
			required: true,
		},
		selectedShippingOption: {},
		isLastRow: {
			type: Boolean,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
		numberOfProductsSentFromStore: {
			type: Number,
			default: 0,
		},
		firstShippingMethod: {
			type: Boolean,
			default: false,
		},
		isAllProductsSentFromStore: {
			type: Boolean
		},
		canShipNow: {
			type: Boolean
		},
		isDownload: {
			type: Boolean,
			default: false,
		},
		normalShippingPrice: {},
	},
	data() {
		return {
			todaysDate: new Date(),
			optionSelectorOpen: false,
			selectedPerk: null,
			selectedDropdownIndex: 0,
		};
	},
	mounted() {
		if (this.selected && this.shippingMethod.optionInfo && this.shippingMethod.optionInfo.defaultToFirstOption && ! this.selectedShippingOption && this.availableOptions && ! this.isAllProductsSentFromStore) {
			this.handlePreSelectedOption();
		}
		bus.$on('checkout:setperk', this.setPerk);
	},
	beforeDestroy() {
		bus.$off('checkout:setperk', this.setPerk);
	},
	methods: {
		convertToCdnUrl,
		tc: t.prefix('CHECKOUT.STOCK'),
		tp: t.prefix('POSTNORD'),
		setPerk (perk) {
			this.selectedPerk = perk;
		},
		handleDropdownSelect (value) {
			this.selectedDropdownIndex = value.index;
			this.selectOption(this.availableOptions[this.selectedDropdownIndex]);
		},
		handlePreSelectedOption () {
			if (this.selectedMethodId === 26) { /* Checks if Airmee */
				for (let i = 0; i < this.availableOptions.length; i++) {
					if (this.availableOptions[i].deliveryHours === '17:00-22:00') {
						this.selectedDropdownIndex = i;
						break;
					}
				}
			} else {
				this.selectedDropdownIndex = 0;
			}
			this.selectOption(this.availableOptions[this.selectedDropdownIndex]);
		},
		selectOption (option) {
			if (option) {
				localSessionStorage.set('checkout:selectedShippingOption', JSON.stringify(option));

				// Used for extra data like box id and delivery date
				switch (this.selectedMethodId) {
					case 100:
						option.type = 'service_point';
						option.value = option.providerLocationId;
						break;
					case 1:
						option.type = 'service_point';
						option.value = option.providerLocationId;
						break;
					case 26:
						option.type = 'desired_delivery_date';
						option.value = option.deliveryDateTimeFromUtc;
						break;
					case 27:
						option.type = 'service_point';
						option.value = option.providerLocationId;
						break;
					case 28:
						const posId = option.properties.sort_code.toString();
						const availabilityToken = this.shippingMethod.bookingReference.toString();

						option.type = 'posId';
						option.value = posId + ',' + availabilityToken;
						break;
					case 29:
						const sortCode = option.properties.sort_code.toString();
						const bookingReference = this.shippingMethod.bookingReference.toString();
						const time = option.properties['eta.datetime_Local'].toString();

						option.type = 'sortCode';
						option.value = sortCode + ',' + bookingReference + ',' + time;
						break;
					case 33:
						option.type = 'service_point';
						option.value = option.providerLocationId;
						break;
				}
			}

			this.$emit('update:selectedShippingOption', option);
			this.optionSelectorOpen = false;
		},
		getBudbeeOption (op) {
			const [deliveryDate, deliveryTime] = op.date.split(' ')

			const date = new Date(deliveryDate);
			let day = format(date, 'dddd', {
				locale: svLocale,
			});

			const today = new Date();

			today.setHours(0);
			today.setMinutes(0);
			today.setSeconds(0);
			today.setMilliseconds(0);

			date.setHours(0);
			date.setMinutes(0);
			date.setSeconds(0);
			date.setMilliseconds(0);

			const daysDifference = differenceInDays(date, today);
			let inStockLabel = daysDifference + ' dagar'; // @TODO översätt
			if (daysDifference === 0) {
				day = 'Ikväll (' + day + '),'; // @TODO översätt
				inStockLabel = 'Ikväll';
			} else if (daysDifference === 1) {
				day = 'Imorgon (' + day + '),'; // @TODO översätt
				inStockLabel = 'Imorgon';
			}

			return {
				value: deliveryDate,
				subLabel: deliveryDate + ' ' + deliveryTime,
				type: 'desired_delivery_date',
				label: day + ' ' + deliveryTime + '-' + op.date.split(' ')[4],
				inStockLabel,
			};
		},
		getPostnordPackageOption (op) {
			const addr = op.visitingAddress;
			let streetName = addr.streetName;
			if (addr.streetNumber) {
				streetName += ' ' + addr.streetNumber;
			}
			return {
				value: op.servicePointId,
				type: 'service_point',
				label: op.name,
				subLabel: streetName + ', ' + addr.postalCode + ' ' + addr.city,
			};
		},
		getDefaultOptions (op) {
			const date = new Date(op.date);
			let day = format(date, 'dddd', {
				locale: svLocale,
			});

			const today = new Date();

			today.setHours(0);
			today.setMinutes(0);
			today.setSeconds(0);
			today.setMilliseconds(0);

			date.setHours(0);
			date.setMinutes(0);
			date.setSeconds(0);
			date.setMilliseconds(0);

			const daysDifference = differenceInDays(date, today);
			let inStockLabel = daysDifference + ' dagar'; // @TODO översätt
			if (daysDifference === 0) {
				day = 'Ikväll (' + day + ')'; // @TODO översätt
				inStockLabel = 'Ikväll';
			} else if (daysDifference === 1) {
				day = 'Imorgon (' + day + ')'; // @TODO översätt
				inStockLabel = 'Imorgon';
			}

			let deliveryHours = '18:00-22:00';
			let value = op.date;
			let type = 'desired_delivery_date';

			if ([26,29].includes(this.shippingMethod.value)) {
				deliveryHours = op.startTime + '-' + op.endTime;
				value += ' ' + deliveryHours;
				if (this.shippingMethod.value === 29 /*Instabox Home*/) {
					type = 'sortCode';
					value = op.sortCode + ',' + op.availabilityToken  + ',' + value;
				}
			}

			return {
				value: value,
				subLabel: op.date + ' ' + deliveryHours,
				type: type,
				label: day,
				inStockLabel,
				deliveryHours,
			};
		},
		getInstaboxOption (op) {
			return {
				value: op.sortCode,
				type: 'instabox_sort_code',
				label: op.description,
				directions: op.directions,
				inStockLabel: op.etaDay,
			};
		},
		getBudbeeBoxOptions (op) {
			return {
				value: op.id,
				type: 'service_point',
				label: op.label,
				directions: op.directions,
				inStockLabel: op.estimatedDelivery ? op.estimatedDelivery : 'Info saknas',
			};
		},
		getUnreleasedDate () {
			const today = new Date();
			let prodRelease = null;
			this.cart.rows.forEach(row => {
				if (prodRelease === null) {
					prodRelease = row.product.release;
				}
				const date = new Date(row.product.release.timestamp * 1000);
				if (date > today) {
					prodRelease = row.product.release;
				}
			});
			return releaseToString(prodRelease);
		},
	},
	computed: {
		selectedOptionIsAvailable () {
			if (this.availableOptions && this.selectedShippingOption) {
				return this.availableOptions.some(el => el.value === this.selectedShippingOption.value);
			}
			return false;
		},
		selected () {
			return this.selectedMethodId === this.shippingMethod.id;
		},
		availableOptions () {
			// if (this.shippingMethod.id === 19 /*best transport*/
			// 	&& this.options && this.options.length
			// ) {
			// 	// Om varorna inte finns i lager (i CL) skall alternativen begränsas för best.
			// 	if ((! this.stockAvailability.inWebStock && ! this.stockAvailability.releaseDate) || (this.numberOfProductsSentFromStore > 0 && ! this.firstShippingMethod) || ! this.canShipNow) {
			// 		// Någon produkt finns ej i lager.
			// 		return [{
			// 			value: this.options[0].value, // Spelar ingen roll vad vi säger till best.
			// 			subLabel: 'Kvällstid (18:00-22:00)',
			// 			type: 'desired_delivery_date',
			// 			label: 'Så fort varorna kommer in i lager',
			// 		}];
			// 	}
			// 	if (this.stockAvailability.releaseDate) {
			// 		// Någon/några produkter har ej släppts.
			// 		return [{
			// 			value: this.options[0].value, // Spelar ingen roll vad vi säger till best.
			// 			subLabel: 'Kvällstid (18:00-22:00)',
			// 			type: 'desired_delivery_date',
			// 			label: 'Release ' + this.getUnreleasedDate(),
			// 		}];
			// 	}
			// } else if (this.shippingMethod.value === 26 || this.shippingMethod.value === 29 /*Airmee or Instabox */) {
			// 	// A product isn't in stock show special option for Airmee or Instabox.
			// 	if ((! this.stockAvailability.inWebStock && ! this.stockAvailability.releaseDate) || (this.numberOfProductsSentFromStore > 0 && ! this.firstShippingMethod)) {
			// 		// Någon produkt finns ej i lager.
			// 		return [{
			// 			value: this.options[0].value, // Spelar ingen roll vad vi sparar.
			// 			subLabel: 'Kvällstid ('+ this.options[0].deliveryHours  +')',
			// 			type: 'desired_delivery_date',
			// 			label: this.isAllProductsSentFromStore ? this.tc('WAREHOUSE_SHIPPING_ASAP') : this.tc('STORE_SHIPPING_ASAP')
			// 		}];
			// 	}
			// 	if (this.stockAvailability.releaseDate) {
			// 		// A product has not been released show special option for Airmee.
			// 		return [{
			// 			value: this.options[0].value, // Spelar ingen roll vad vi sparar.
			// 			subLabel: 'Kvällstid ('+ this.options[0].deliveryHours  +')',
			// 			type: 'desired_delivery_date',
			// 			label: 'Release ' + this.getUnreleasedDate(),
			// 		}];
			// 	}
			// } else if (this.shippingMethod.value === 28 || this.shippingMethod.value === 27 && this.options && this.options.length /*Instabox, BudbeeBox*/) {
			// 	if (this.shippingMethod.value === 27) {
			// 		this.shippingMethod.description = this.shippingMethod.description + '. Om paketet är för stort skickas din beställning med Budbee Hemleverans.';
			// 	}
			// 	else if (this.shippingMethod.value === 28) {
			// 		this.shippingMethod.description = this.shippingMethod.description + '. Om paketet är för stort skickas din beställning med Instabox HOME eller Postnord.';
			// 	}
			// 	if (! this.stockAvailability.inWebStock || this.stockAvailability.releaseDate || (this.numberOfProductsSentFromStore > 0 && ! this.firstShippingMethod)) {
			// 		let infoLabel = '';

			// 		if ((! this.stockAvailability.inWebStock && ! this.stockAvailability.releaseDate) || (this.numberOfProductsSentFromStore > 0 && ! this.firstShippingMethod) || ! this.canShipNow) {

			// 			// Någon produkt finns ej i lager.
			// 			infoLabel = 'Levereras så fort varorna kommer in i lager';
			// 		} else if (this.stockAvailability.releaseDate) {
			// 			// A product has not been released.
			// 			infoLabel = 'Release ' + this.getUnreleasedDate();
			// 		}

			// 		const pattern = /\s?\(.*?\)$/;
			// 		this.options.forEach((option) => {
			// 			option.label = option.label.replace(pattern, '');
			// 			option.subLabel = infoLabel;
			// 		});
			// 		return this.options;
			// 	}
			// }
			// return this.options;

			// Special cases if some product is not in stock
			if (! this.stockAvailability.inWebStock && this.shippingMethod.options) {
				// If instabox home or airmee, just show night time
				// if ((this.shippingMethod.id === 26 || this.shippingMethod.id === 29)) {
				// 	// If unreleased
				// 	if (this.stockAvailability.releaseDate) {
				// 		return [{
				// 			description: 'Realease ' + this.getUnreleasedDate(),
				// 			properties: 'Kvällstid (17:00 - 22:00)'
				// 		}]
				// 	} else {
				// 		// if released
				// 		return [{
				// 			description: this.tc('STORE_OUT_OF_STOCK'),
				// 			properties: 'Kvällstid (17:00 - 22:00)'
				// 		}]
				// 	}
				// } else
				if (this.shippingMethod.id === 28 || this.shippingMethod.id === 27) {
					// If instabox box or budbee box, remove the time
					for (const option of this.shippingMethod.options) {
						option.description = option.description.substring(0, option.description.indexOf("("));
					}
				}
			}

			return this.shippingMethod.options;
		},
		options () {
			const opts = [];
			if (this.shippingMethod.options && this.shippingMethod.options.length > 0) {
				this.shippingMethod.options.forEach((op,index) => {
					// Show maximum 10 options.
					if (! (index > 9)) {
						switch (this.shippingMethod.value) {
							case 25:
								opts.push(this.getBudbeeOption(op));
								break;
							case 1:
								opts.push(this.getPostnordPackageOption(op));
								break;
							case 27:
								opts.push(this.getBudbeeBoxOptions(op));
								break;
							case 28:
								opts.push(this.getInstaboxOption(op));
								break;
							default:
								opts.push(this.getDefaultOptions(op));
								break;
						}
					}
				});
			}

			//There are no options
			if (opts.length === 0) {
				return null;
			}

			return opts;
		},
		price () {
			if (this.user.settings.show_prices_excluding_vat) {
				return 0.8*this.shippingMethod.price;
			} else {
				return this.shippingMethod.price;
			}
		},
		formattedPrice () {
			const priceObj = {
				price: this.shippingMethod.price,
				vat: 0.2*this.shippingMethod.price,
				currency: 'SEK',
			};
			return formatProductPrice(priceObj, this.user.settings.show_prices_excluding_vat);
		},
		priceToPayIsZero () {
			if (! this.selectedPerk || this.price > 130) {
				return false;
			} else {
				return true;
			}
		},
		hasRebate () {
			if (! this.selectedPerk) {
				return false;
			} else {
				return true;
			}
		},
		getDeliveryInfo () {
			if (this.cartHasUnreleasedProducts) {
				if (this.selected && this.selectedShippingOption) {
					return this.selectedShippingOption.label;
				}
				else {
					return 'Release ' + this.getUnreleasedDate();
				}
			} else if (!this.stockAvailability.inWebStock || (this.isAllProductsSentFromStore && !this.firstShippingMethod) || (this.numberOfProductsSentFromStore > 0 && !this.firstShippingMethod)) {
				return this.isAllProductsSentFromStore ? this.tc('WAREHOUSE_SHIPPING_ASAP') : this.tc('STORE_SHIPPING_ASAP');
			}

			// Budbee
			// if (this.shippingMethod.id === 25) {
			// 	const optionInfo = this.getBudbeeOption(this.shippingMethod.options);

			// 	return 'Leverans ' + optionInfo.label;
			// }

			// Instabox Home
			// if (this.shippingMethod.id === 29) {
			// 	const optionInfo = this.getDefaultOptions(this.shippingMethod.options);

			// 	return 'Leverans ' + optionInfo.label + ' ' + optionInfo.deliveryHours;
			// }

			// if (this.options && ! this.selected) {
			// 	if (this.options[0].inStockLabel && this.options[0].subLabel) {
			// 		return 'Leverans ' + this.options[0].label + ', ' + this.options[0].subLabel.substring(10, 22);
			// 	} else if (this.options[0].inStockLabel) {
			// 		return 'Leverans ' + this.options[0].label;
			// 	}
			// }

			let date = new Date();

			if (this.selected && this.selectedShippingOption && (this.selectedShippingOption.type !== 'service_point' || this.shippingMethod.id === 27)) {
				date = new Date(this.selectedShippingOption.value);
				const day = format(date, 'dddd', {
					locale: svLocale,
				});

				switch (this.selectedShippingOption.type) {
					case 'desired_delivery_date':
						return 'Förväntad leverans på ' + day ;
						break;
					default:
						return this.selectedShippingOption.label;
						break;
				}
			} else {
				let	estimatedDeliveryDays = 1;

				if ([1, 2, 3, 20].includes(this.shippingMethod.id) && date.getHours() > 14) {
					estimatedDeliveryDays += 1;
				}

				date.setDate(date.getDate() + estimatedDeliveryDays);
				let day = format(date, 'dddd', {
					locale: svLocale,
				});

				if ([1, 2, 3, 20].includes(this.shippingMethod.id)) {
					if (day.substring(0, 6) === 'lördag') {
						date = new Date();
						estimatedDeliveryDays += 2;
						date.setDate(date.getDate() + estimatedDeliveryDays);
						day = format(date, 'dddd', {
							locale: svLocale,
						});
					}

					if (day.substring(0, 6) === 'söndag') {
						date = new Date();
						estimatedDeliveryDays += 1;
						date.setDate(date.getDate() + estimatedDeliveryDays);
						day = format(date, 'dddd', {
							locale: svLocale,
						});
					}
				}

				return this.shippingMethod.isPostnordPallet ? 'Förväntad leverans 1-2 vardagar' : 'Förväntad leverans på ' + day ;
			}
		},
		cartSum () {
			return getCartSum(this.cart);
		},
		remainingForFreeShipping () {
			if (this.shippingMethod.id === 20) {
				const currency = 'SEK';
				const sumRemaining = businessVariables.minimumPurchaseForFreeShipping[currency] - this.cartSum;
				let isDisabled = false;
				if (sumRemaining <= 0) {
					return null;
				} else {
					isDisabled = true;
				}
				bus.$emit('freeShipppingIsAvailable', isDisabled);
				return formatPrice(sumRemaining, currency) + ' kvar till fri frakt';
			} else { return null; }
		},
		showSubTitle () {
			if (this.shippingMethod.options) {
				return this.shippingMethod.options[0].description !== '';
			}
			return false;
		},
		...mapState({
			user: 'user',
		}),
		hasOptions () {
			return this.shippingMethod.options && this.shippingMethod.options.length > 0;
		},
		cartHasUnreleasedProducts () {
			return hasUnreleasedProducts(this.cart);
		},
		isReleased () {
			return stockUtils.isReleased(this.stockAvailability.releaseDate);
		},
		stockClass () {
			if ((this.isAllProductsSentFromStore && !this.firstShippingMethod) || (this.numberOfProductsSentFromStore > 0 && !this.firstShippingMethod) || (! this.canShipNow && ! this.firstShippingMethod)) {
				return 'stock-icon-outofstock-incentral';
			} else {
				return this.stockAvailability.inWebStock ? 'stock-icon-in-supplier-stock' : 'stock-icon-outofstock-incentral';
			}
		},
		shippingMethodOptions () {
			return this.availableOptions.map((value, index) => {
				return {
					index: index,
					label: ! this.stockAvailability.inWebStock && (this.shippingMethod.id == 26 || this.shippingMethod.id == 29) ? this.tc('STORE_OUT_OF_STOCK') : value.description != '' ? value.description : value.name,
					description: value.properties["directions.long"] ? value.properties["directions.long"] : value.addressLine1 ? value.addressLine1 + ', ' + value.postalCode + ' ' + value.city : ! this.stockAvailability.inWebStock && (this.shippingMethod.id == 26 || this.shippingMethod.id == 29) ? '' : null
				};
			});
		},
		formatImageProvider () {
			return this.shippingMethod.providerCode.toLowerCase();
		}
	},
	watch: {
		selected () {
			if (this.selected) {
				if (this.hasOptions) {
					this.handlePreSelectedOption();
				} else {
					this.selectOption(null);
				}
			}
		},
	},
};
</script>
